import i18n from "../i18n"

//设备配对-库
export function netEqu() {
    let netList=[
        { name: i18n.t('equipmentPair.searchTypeAll'),en:"" },
        { name: i18n.t('equipmentPair.searchTypeController'),en:"GateWay" },
        // { name: '取电主机',en:"" }
    ];
    return netList;
}

//设备配对-终端设备库
export function terminalEqu() {
    let terminalList=[
        { name: i18n.t('equipmentPair.searchTypeAll') ,en:""},
        // { name: '门禁' ,en:"Door"},
        { name: i18n.t('equipmentPair.deviceLock') ,en:"Lock"},
        // { name: '闭门感应器' ,en:""},
        { name: i18n.t('equipmentPair.deviceSensor') ,en:"HumDet"},
    ];
    return terminalList;
}
